import React, { Fragment, useState, useEffect, useCallback, useMemo } from 'react';
import Grid from '@material-ui/core/Grid';
// import Button from '@material-ui/core/Button';
import { useParams } from 'react-router-dom';
import AddMesh from './AddMesh/newAddMesh';
//redux
import { useDispatch, useSelector } from 'react-redux';
import { doGetMeshList, doDeleteMesh } from '../../../../../redux/thunks/mesh';
import { selectCurrentPartner } from '../../../../../redux/selectors/authentication';
import Table from '../../../../../components/Table/Table';
import Button from '../../../../../components/Buttons/Button';
import SquareDelete from '../../../../../components/SquareDelete/SquareDelete';
import { Search } from '../../../../../utils/Search';
import '../../../../../styles/common.scss';
import { meshConfiguredStateRender, statusText } from '../../../../../utils/Common';
import ModalAlert from '../../../../../components/Modals/ModalAlert';
import useIsMobile from '../../../../../hooks/useIsMobile';
import MobileTable from '../../../../../components/MobileTable/MobileTable';
import SDialog from '../../../../../components/SDialog/SDialog';
import Typography from '../../../../../components/Typography/Typography';
import FlexRow from '../../../../../components/FlexBox/FlexRow';
import SButton from '../../../../../components/SButton/SButton';

const MeshIo = () => {

  const { customerId } = useParams();

  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const [showAddMesh, setAddMesh] = useState(false);
  const [filters, setFilters] = useState({ name: '', serialNumber: '', siteName: '' });
  const [pagination, setPagination] = useState({ total: 0, currentPage: 1, perPage: 7 });
  const [showModal, setShowModal] = useState(false);
  const [rowDataSelected, setRowData] = useState(null);

  const { currentPartner } = useSelector((state) => ({
    currentPartner: selectCurrentPartner(state),
  }));

  const meshData = useSelector((state) => state.mesh.meshIOs);
  const sites = useSelector((state) => state.organisation.sites);

  const getMeshList = useCallback(() => {
    if (currentPartner && customerId) dispatch(doGetMeshList(currentPartner.partnerId, customerId));
  }, [currentPartner, customerId, dispatch]);

  useEffect(() => {
    getMeshList();
  }, [getMeshList]);

  useEffect(() => {
    setPagination(prev => ({ ...prev, total: meshData?.length ? meshData?.length : 0 }))
  }, [meshData?.length, setPagination]);

  const convertToHex = (value) => {
    let hexString = value.toString(16);

    // Ensure the hexadecimal string has at least two characters
    if (hexString.length % 2 !== 0) {
      hexString = '0' + hexString;
    }

    // Split the hexadecimal string into groups of two characters
    const hexGroups = [];
    for (let i = 0; i < hexString.length; i += 2) {
      hexGroups.push(hexString.slice(i, i + 2));
    }

    // Join the groups with periods to get the "xx.xx.xx" format
    const formattedHex = hexGroups.join('.');

    return formattedHex;
  };

  const columns = useMemo(() => {
    const commonColumns = [
      { title: 'Mesh I/O Name', field: 'name', name: 'name' },
      {
        title: 'Serial Number',
        field: 'serialNumber',
        name: 'serialNumber',
      },
      {
        title: 'FW Version',
        field: 'firmwareVersion',
        render: (columnProps, rowData) => {
          return convertToHex(rowData.firmwareVersion);
        },
      },
      {
        title: 'Site',
        field: 'siteName',
        name: 'siteName',
      },
      {
        title: 'State',
        field: 'meshConfiguredState',
        render: (columnProps, rowData) => {
          return meshConfiguredStateRender(rowData.configurationStatus);
        },
      },
      {
        title: 'Status',
        field: 'cloudStatus',
        render: (columnProps, rowData) => {
          return statusText(rowData.connectivityStatus);
        },
      },
      {
        title: 'Networks',
        field: 'networkName',
        name: 'networkName',
      },
      {
        title: 'Function Type',
        field: 'formattedFunction',
        name: 'formattedFunction',
      },
      {
        title: 'Function Name',
        field: 'functionName',
        name: 'functionName',
      },
    ]

    const actions = [
      {
        title: 'Action',
        render: (columnProps, rowData) => {
          return (
            <SquareDelete
              color={'#ff535a'}
              onPress={() => {
                // deleteMesh(rowData.serialNumber);
                setShowModal(true);
                setRowData(rowData);
              }}
              style={{ width: '2rem', height: '2rem', padding: '0' }}
            />
          );
        },
        renderM: (columnProps, rowData) => {
          return (
            <SquareDelete
              color={'#ff535a'}
              onPress={() => {
                // deleteMesh(rowData.serialNumber);
                setShowModal(true);
                setRowData(rowData);
              }}
              style={{ width: '2rem', height: '2rem', padding: '0' }}
            />
          );
        },
      },
    ]

    return {
      allColumns: [...commonColumns, ...actions],
      commonColumns,
      actions
    }

  }, [])

  const mobileFiltersConfig = useMemo(() => {
    return [
      { name: "Mesh I/O Name", key: "name", type: "search" },
      { name: "Serial Number", key: "serialNumber", type: "search" },
      { name: "Site Name", key: "siteName", type: "search" },
      { name: "Network Name", key: "networkName", type: "search" },
      { name: "Function Type", key: "formattedFunction", type: "search" },
      { name: "Function Name", key: "functionName", type: "search" },
    ]
  }, []);

  const deleteMesh = useCallback(
    (serialNumber) => {
      dispatch(
        doDeleteMesh(currentPartner.partnerId, customerId, serialNumber, (s) => {
          if (s === 'success') {
            getMeshList();
            setShowModal(false);
          }
        }),
      );
    },
    [currentPartner.partnerId, customerId, dispatch, getMeshList],
  );

  const hSearchChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFilters(prev => ({
      ...prev,
      [name]: value
    }))
  };

  const search = {
    onChange: hSearchChange,
  };

  const filteredData = useCallback(() => {
    let data = meshData ? meshData : [];
    if (filters.name !== '') {
      data = Search(data, 'name', filters.name);
    }
    if (filters.serialNumber !== '') {
      data = Search(data, 'serialNumber', filters.serialNumber);
    }
    if (filters?.siteName && filters.siteName !== '') {
      data = Search(data, 'siteName', filters.siteName);
    }

    if (filters?.networkName && filters.networkName !== '') {
      data = Search(data, 'networkName', filters.networkName);
    }

    if (filters?.functionName && filters.functionName !== '') {
      data = Search(data, 'functionName', filters.functionName);
    }

    if (filters?.formattedFunction && filters.formattedFunction !== '') {
      data = Search(data, 'formattedFunction', filters.formattedFunction);
    }

    if (!isMobile) {
      data = data.slice(
        (pagination.currentPage - 1) * 7,
        pagination.currentPage * pagination.perPage,
      );
    }

    return data;
  }, [
    filters.name,
    filters.serialNumber,
    filters.siteName,
    filters.networkName,
    filters.functionName,
    filters?.formattedFunction,
    meshData,
    pagination.currentPage,
    pagination.perPage,
    isMobile
  ]);

  const changePage = (p) => {
    const { page, per_page } = p;
    setPagination(prev => ({
      ...prev,
      currentPage: page,
      perPage: per_page
    }));
  };

  return (
    <Fragment>
      <Grid container style={{ marginTop: '1rem' }}>
        {showAddMesh && (
          <AddMesh
            togglePopup={() => {
              setAddMesh(false);
            }}
            showAddMesh={showAddMesh}
            partnerId={currentPartner.partnerId}
            customerId={customerId}
          />
        )}
        <FlexRow justifyContent='space-between' styles={{ marginBottom: '1rem' }}>
          <Typography variant={"h7M"}>Mesh I/O</Typography>
          <SButton
            minWidth
            onClick={() => {
              setAddMesh(true);
            }}
            disabled={sites == null || sites.length === 0}
          >
            Add Mesh I/O
          </SButton>
        </FlexRow>
        <>
          {isMobile ?
            <MobileTable
              columns={columns?.commonColumns}
              data={filteredData()}
              actions={columns.actions}
              filtersConfig={mobileFiltersConfig}
              filters={filters}
              setFilters={setFilters}
              emptyMessage="No Mesh I/O's Found"
            />
            : <Table
              columns={columns?.allColumns}
              data={filteredData()}
              options={{ search }}
              pagination={pagination}
              changePage={changePage}
              defaultMessage={"No Mesh I/O's Found"}
            />}
          {showModal && (
            <SDialog
              title='Delete Mesh I/O'
              open={showModal}
              onClose={() => {
                setShowModal(false);
              }}
              secondaryButtonConfig={{
                text: 'Cancel',
                onClick: () => {
                  setShowModal(false);
                }
              }}
              primaryButtonConfig={{
                text: 'Delete',
                color: 'error',
                onClick: () => { deleteMesh(rowDataSelected?.serialNumber) }
              }}
            >
              <Typography variant={"b1M"} style={{ padding: '1.5rem 0' }}>
                Are you sure you want to delete {rowDataSelected?.name ? rowDataSelected?.name : ''} ? This action is non
                reversible and will cause you to lose all data associated with this customer/ s</Typography>
            </SDialog>
          )}
        </>
      </Grid>
    </Fragment>
  );
};

export default MeshIo;
